import { useEffect } from 'react';
import { useLocation } from 'wouter';

import { useSearchQuery } from './location';

export const useResetPasswordRedirect = () => {
  const [query] = useSearchQuery();
  const [_, setLocation] = useLocation();

  const isRedirect = query.get('cmd') === 'resetPassword';
  const token = query.get('token');

  useEffect(() => {
    if (!isRedirect) return;
    setLocation(`/reset-password?token=${token}`, { replace: true });
  }, [isRedirect, token, setLocation]);
};
